import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DirectDebitFormComponentService } from '../../services/direct-debit-form-component/direct-debit-form.component.service';
import { QMSanitiseDirective } from '@domgen/dgx-fe-qm';
import {
  DescriptionListComponent,
  DescriptionListItemComponent,
} from '@domgen/dgx-fe-components/list';
import { NgIf, AsyncPipe } from '@angular/common';

@Component({
  selector: 'checkout-user-direct-debit-details',
  templateUrl: './user-direct-debit-details.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    NgIf,
    DescriptionListComponent,
    DescriptionListItemComponent,
    QMSanitiseDirective,
    AsyncPipe,
  ],
})
export class UserDirectDebitDetailsComponent {
  constructor(readonly cs: DirectDebitFormComponentService) {}
}
